import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';

import PropTypes from 'prop-types';

import RecommendedBadge from '../../../CommonUI/RecommendedBadge';
import DeviceCard from '../DeviceCard';
import { cardWidth } from '../DeviceCard/DeviceCard.Styles';

import styles from './DevicesList.Styles';

function renderDeviceCard(
  { item, index },
  devices,
  onSelectDevicePress,
  isEditMode,
  selectedDevice,
) {
  const stylesArr = [];

  const marginStyle =
    index === 0
      ? styles.firstCardContainerStyle
      : index === devices?.length - 1
      ? styles.lastCardContainerStyle
      : undefined;

  const recommendedStyle = item?.isRecommended ? styles.recommendedContainerStyle : undefined;

  stylesArr.push(marginStyle);
  stylesArr.push(recommendedStyle);

  const isSelectedDeviceEditMode = isEditMode && selectedDevice?.id === item.id;

  return (
    <View>
      {item?.isRecommended ? (
        <RecommendedBadge
          i18nKey={'device_upgrade_recommended_title'}
          containerStyle={marginStyle}
        />
      ) : undefined}
      <DeviceCard
        key={`DeviceCard-${item.id || index}`}
        containerStyle={StyleSheet.flatten(stylesArr)}
        onSelectDevicePress={() => onSelectDevicePress(item, index)}
        isSelectedDevice={isSelectedDeviceEditMode}
        {...item}
      />
    </View>
  );
}

const DevicesList = ({ devices, onSelectDevicePress, isEditMode, selectedDevice }) => {
  return (
    <FlatList
      style={styles.flatListStyle}
      contentContainerStyle={styles.flatListContentContainerStyle}
      data={devices}
      renderItem={item =>
        renderDeviceCard(item, devices, onSelectDevicePress, isEditMode, selectedDevice)
      }
      horizontal
      pagingEnabled
      showsHorizontalScrollIndicator={false}
      snapToInterval={cardWidth}
      snapToAlignment="start"
      decelerationRate="fast"
    />
  );
};

DevicesList.defaultProps = {
  onSelectDevicePress: () => {},
};

DevicesList.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
      price: PropTypes.shape({
        upfront: PropTypes.number,
        currency: PropTypes.string,
        recurringCharge: PropTypes.number,
      }).isRequired,
      isRecommended: PropTypes.bool,
    }),
  ),
  onSelectDevicePress: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  selectedDevice: PropTypes.shape({
    id: PropTypes.string,
    brand: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
    price: PropTypes.shape({
      upfront: PropTypes.number,
      currency: PropTypes.string,
      recurringCharge: PropTypes.number,
    }).isRequired,
    isRecommended: PropTypes.bool,
  }),
};

export { renderDeviceCard };
export default DevicesList;
